// Maps tool id -> render(container). Imported only by the tools bundle, so all
// tool code is lazy (it never ships with the main app bundle).
import { calculator } from "./calculator.js";
import { notes } from "./notes.js";
import { todo } from "./todo.js";
import { converter } from "./converter.js";
import { timer } from "./timer.js";
import { worldclock } from "./worldclock.js";
import { color } from "./color.js";
import { password } from "./password.js";
import { qrcode } from "./qrcode.js";
import { text } from "./text.js";
import { random } from "./random.js";
import { calendar } from "./calendar.js";
import { whiteboard } from "./whiteboard.js";
import { markdown } from "./markdown.js";
import { regex } from "./regex.js";
import { flashcards } from "./flashcards.js";
import { cite } from "./cite.js";
import { grade } from "./grade.js";
import { typerace } from "./typerace.js";

export const REGISTRY = { calculator, notes, todo, converter, timer, worldclock, color, password, qrcode, text, random, calendar, whiteboard, markdown, regex, flashcards, cite, grade, typerace };
